import { PropsWithChildren } from "react";

export function StatCard({ children }: PropsWithChildren) {
  return (
    <div className="border rounded-xl border-border bg-white shadow-sm p-2 sm:p-4 min-h-14 flex flex-col gap-4 flex-1 w-full justify-between">
      {children}
    </div>
  );
}
